<div class="summary-card" [ngClass]="{ 'is-missing': !isValidShipment }">
  <div class="summary-card-logo">
    <div class="card-logo">
      <img *ngIf="info.imgSrc" src="assets/icons/{{ info.imgSrc }}.svg" alt="Vessel Sailing info" />
    </div>
  </div>
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div>
        <h5>
          {{ info.title | translate }}
        </h5>
      </div>
      <div class="summary-card-edit" *ngIf="canEdit">
        <button class="btn btn-link" (click)="gotoEdit()"><i class="fa fa-pencil"></i></button>
      </div>
    </div>
    <div class="container-card-body">
      <ng-container *ngIf="!shipment">
        <div class="row">
          <div class="col-12">{{ "LABELS.ISF_ENTITY_IS_MISSING" | translate }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="!!shipment">
        <div class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.CODE_SHIPMENT" | translate }}</div>
          <div class="col-6" *ngIf="shipment.code">{{ "FORM_LABEL." + enumIsfShipmentCode[shipment.code] | translate }}</div>
        </div>
        <div class="row">
          <div class="col-6 card-label">{{ "LABELS.CARRIER" | translate }}</div>

          <div class="col-6">
            {{ shipment?.code === enumIsfShipmentCode.HOUSE ? shipment?.houseBill?.carrier : shipment?.masterBill?.carrier }}
            <div *ngIf="!!getValidationText('carrier')" class="text-error">
              {{ getValidationText("carrier") | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.BILLNUMBER" | translate }}</div>
          <div class="col-6">
            {{ shipment?.code === enumIsfShipmentCode.HOUSE ? shipment?.houseBill?.number : shipment?.masterBill?.number }}
            <div *ngIf="!!getValidationText('number')" class="text-error">
              {{ getValidationText("number") | translate }}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!!getValidationText('bill')">
          <div class="col-12 text-error">
            {{ getValidationText("bill") | translate }}
          </div>
        </div>
      </ng-container>
      <ng-template [ngIf]="connectedEntrySummary?.length">
        <div class="row">
          <div class="col-6 card-label">{{ "LABELS.CONNECTED_ENTRIES" | translate }}</div>
          <div class="col-6" fxLayout="column">
            <div class="connected-entries" [class.connected-entries--all]="!isShowMoreEntries" fxLayout="column">
              <ng-template ngFor [ngForOf]="connectedEntrySummary" let-entry>
                <a [routerLink]="['/entry-summaries-management', entry.id]">{{ entry.name }}</a>
              </ng-template>
            </div>
            <ng-template [ngIf]="connectedEntrySummary.length > 3">
              <button type="button" class="btn btn-link btn-sm" fxFlexAlign="baseline" (click)="isShowMoreEntries = !isShowMoreEntries">
                {{ isShowMoreEntries ? ("BUTTON.SHOW_MORE" | translate) : ("BUTTON.SHOW_LESS" | translate) }}
              </button>
            </ng-template>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
